import brandApiFactory from '../../modules/brand/brandApi';

/* Actions */
import {
  getBrandProductsActionCreators, 
  getNextBrandProductsActionCreators, 
  getBrandInfoActionCreators, 
  getBrandByIdActionCreators, 
  getBrandByProductBrandNameActionCreators, 
  getSimilarBrandsActionCreators
} from '../actions/brandActions';

/* Utils */
import {generateDefaultAsyncSaga, generateDefaultAsyncWatcher} from '../core/reduxUtils';

function brandPageSagasFactory({storefrontApiClient}) {
  const brandApi = brandApiFactory(storefrontApiClient);

  const getBrandInfoSagas = generateDefaultAsyncSaga(
    brandApi.getBrandInfo,
    getBrandInfoActionCreators,
    payload => [
      payload.params,
    ],
  );

  const getBrandProductsSagas = generateDefaultAsyncSaga(
    brandApi.getBrandProducts,
    getBrandProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
    ],
  );

  const getNextBrandProductsSaga = generateDefaultAsyncSaga(
    brandApi.getBrandProducts,
    getNextBrandProductsActionCreators,
    payload => [
      payload.params,
      payload.cookies,
    ],
  );

  const getBrandByIdSagas = generateDefaultAsyncSaga(
    brandApi.getBrandById,
    getBrandByIdActionCreators,
    payload => [
      payload.params,
    ],
  );

  const getBrandByProductNameSagas = generateDefaultAsyncSaga(
    brandApi.getBrandByProductBrandName,
    getBrandByProductBrandNameActionCreators,
    payload => [
      payload.params,
    ],
  );

  const getSimilarBrandsSagas = generateDefaultAsyncSaga(
    brandApi.getSimilarBrands,
    getSimilarBrandsActionCreators,
    payload => [
      payload.params,
    ]
  )

  const watchGetBrandPages = generateDefaultAsyncWatcher(
    'GET_BRAND_PRODUCTS',
    getBrandProductsSagas
  );

  const watchGetBrandInfo = generateDefaultAsyncWatcher(
    'GET_BRAND_INFO',
    getBrandInfoSagas
  );

  const watchGetNextBrandProducts = generateDefaultAsyncWatcher(
    'GET_NEXT_BRAND_PRODUCTS',
    getNextBrandProductsSaga,
  );

  const watchGetBrandById = generateDefaultAsyncWatcher(
    'GET_BRAND_BY_ID',
    getBrandByIdSagas
  );

  const watchGetBrandByProductBrandName = generateDefaultAsyncWatcher(
    'GET_BRAND_BY_NAME',
    getBrandByProductNameSagas
  );

  const watchGetSimilarBrands = generateDefaultAsyncWatcher(
    'GET_SIMILAR_BRANDS',
    getSimilarBrandsSagas
  )

  const brandPageSagas = [
    watchGetBrandPages(),
    watchGetBrandInfo(),
    watchGetNextBrandProducts(),
    watchGetBrandById(),
    watchGetBrandByProductBrandName(),
    watchGetSimilarBrands(),
  ];

  return brandPageSagas;
}

export default brandPageSagasFactory;
